import React, { useMemo } from 'react';
import { Button } from '@getro/rombo';
import { Trash } from 'lucide-react';
import { Flex, Text } from 'rebass/styled-components';

export const useApiKeysData = ({ apiKeys = [], onClickRevoke }) => {
  const columns = [
    {
      Header: 'NAME',
      accessor: 'name',
      width: '30%',
      disableSortBy: true,
      show: true,
    },
    {
      Header: 'KEY',
      accessor: 'key',
      width: '40%',
      disableSortBy: true,
      show: true,
    },
    {
      Header: 'LAST USED',
      accessor: 'lastUsed',
      width: '20%',
      disableSortBy: true,
      show: true,
    },
    {
      Header: '',
      accessor: 'actions',
      width: '10%',
      disableSortBy: true,
      show: true,
    },
  ];

  const maskApiKey = (key) => (key ? `${key.substring(0, 4)}${'•'.repeat(16)}` : '');

  const formatLastUsed = (lastUsedAt) =>
    lastUsedAt
      ? new Date(lastUsedAt).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })
      : 'Never used';

  const rows = useMemo(
    () =>
      apiKeys.map((apiKey) => ({
        id: apiKey.id,
        name: (
          <Flex alignItems="center" pl="8px">
            <Text fontSize="14px" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {apiKey.label}
            </Text>
          </Flex>
        ),
        key: (
          <Flex alignItems="center">
            <Text
              fontSize="14px"
              color="text.main"
              sx={{
                fontFamily: 'Source Code Pro, monospace',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {maskApiKey(apiKey.tokenPrefix)}
            </Text>
          </Flex>
        ),
        lastUsed: (
          <Flex alignItems="center">
            <Text fontSize="14px">{formatLastUsed(apiKey.lastUsedAt)}</Text>
          </Flex>
        ),
        actions: (
          <Flex alignItems="center" justifyContent="flex-end" width="100%">
            <Button
              icon={Trash}
              size="small"
              variant="tertiary"
              onClick={() => onClickRevoke(apiKey)}
              sx={{ px: '8px', position: 'relative', right: '-8px', flex: '0 0 auto' }}
            />
          </Flex>
        ),
      })),
    [apiKeys, onClickRevoke],
  );

  return {
    columns: columns.filter((column) => column.show),
    rows,
  };
};
